import React, { createContext, useContext, useState } from "react";
import { toast } from 'react-toastify';
import { fetchMailTemplateTableAndFilterSchema } from "model/MailTemplateModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const MailTemplateContext = createContext();

export const MailTemplateProvider = ({ children }) => {
    const { fetchMetadataSchema } = useCommonFilterOptions();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [mailTemplateContextData, setMailTemplateContextData] = useState();

    const fetchMailTemplateContextData = async () => {
        setLoading(true);
        try {
            const response = await fetchMetadataSchema("metadata:mailTemplate", () =>
                fetchMailTemplateTableAndFilterSchema([])
            );
            if (response?.success) {
                setMailTemplateContextData(response?.data);
            }
        } catch (err) {
            toast.error(err);
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <MailTemplateContext.Provider
            value={{ fetchMailTemplateContextData, mailTemplateContextData, loading, error }}
        >
            {children}
        </MailTemplateContext.Provider>
    );
};

export const useMailTemplateContext = () => useContext(MailTemplateContext);
